import React from 'react';
import classnames from 'classnames/bind';
import styles from './Folder.module.scss';

const cx = classnames.bind(styles);

const Folder = ({ view = false, children = null }) => <div className={cx('list', view ? 'expand' : 'fold')}>{children}</div>;

export default Folder;
